
import { Component, Vue } from 'vue-property-decorator';
import HeaderLogo from '@/components/Layout/HeaderLogo.vue';

@Component({ components: { HeaderLogo } })
export default class PortalHeader extends Vue {
  menuItems = [
    { icon: 'mdi-logout', label: 'Log Out', action: this.logout },
  ];

  logout() {
    localStorage.removeItem('JWT_TOKEN');
    window.location.reload();
  }
}
